import React from 'react';
import withTranslate from 'components/withTranslate';
import PropTypes from 'prop-types';
import Icon from 'components/icons/Icon';

export const ErrorMessageRenderer = ({ error, _t, field, id }) => (
  <div className={`error ${field}`} id={id}>
    <Icon type="error-inline" aria-hidden="true" />
    {_t(error, { disableWarning: true })}
  </div>
);

ErrorMessageRenderer.propTypes = {
  error: PropTypes.string.isRequired,
  _t: PropTypes.func.isRequired,
  field: PropTypes.string.isRequired,
  id: PropTypes.string,
};

export default withTranslate(ErrorMessageRenderer);
